import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import store from './store'
import router from './router'
import VueI18n from 'vue-i18n'
import Vuelidate from 'vuelidate'
import messages from './lang'

import './filters'
import './assets/scss/main.scss'

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_LOCAL_API_URL : process.env.VUE_APP_API_URL
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.common['Mobile-App'] = 'true'

Vue.use(VueI18n)
Vue.use(Vuelidate)
Vue.config.productionTip = false

window.addEventListener('resize', () => {
  store.commit('setWidth', window.innerWidth)
})

document.addEventListener('scroll', () => {
  store.commit('setTop', window.pageYOffset || document.documentElement.scrollTop)
})

const i18n = new VueI18n({
  locale: 'es',
  messages
})

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
